export const useGetItemFromLocalStorage = (name: string): string | null => {
  const item = window.localStorage.getItem(name)
  if (!item) return null
  return item
}
